import {
    tss,
} from 'app/tss'

export default tss.create(({
    theme,
}) => {
    const general = 'general'
    const fees = 'fees'

    return {
        root: {
            backgroundColor: theme.palette.secondary[50],
            cursor: 'default',
        },
        gridWrapper: {
            padding: theme.spacing(1),
            display: 'grid',
            gridGap: theme.spacing(1),
            gridTemplateAreas: `
            "${general} ${general} ${general}"
            "${fees} ${fees} ${fees}"`,
            gridTemplateColumns: 'repeat(3, 1fr)',
        },
        general: {
            gridArea: general,
            gridTemplateColumns: 'repeat(3, 1fr)',
        },
        fees: {
            gridArea: fees,
            gridTemplateColumns: '1fr !important',
        },
    }
})
